import { render, staticRenderFns } from "./AuthBindPhone.vue?vue&type=template&id=36ce64cc&"
import script from "./AuthBindPhone.vue?vue&type=script&lang=js&"
export * from "./AuthBindPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports